export default __webpack_public_path__ + "static/media/Map.3ecda39b.png";